<template>
    <div
        v-if="searchResults.numberOfPages > 1"
        class="flex flex-wrap justify-center gap-x-1 gap-y-2 my-8"
    >
        <!-- Before -->
        <template
            v-for="page in searchResults.beforeCurrent"
            :key="page"
        >
            <Button
                :as="as"
                @click="handlePageClick($event)"
                :href="`${url}${separator}${RequestQueryKeyEnum.PaginationPage}=${page}`"
                color="light"
                :data-page="page"
            >
                {{ page }}
            </Button>
        </template>

        <!-- Current -->
        <Button
            :as="as"
            @click="handlePageClick($event)"
            :href="`${url}${separator}${RequestQueryKeyEnum.PaginationPage}=${searchResults.currentPage}`"
            color="dark"
            :data-page="searchResults.currentPage"
        >
            {{ searchResults.currentPage }}
        </Button>

        <!-- After -->
        <template
            v-for="page in searchResults.afterCurrent"
            :key="page"
        >
            <Button
                :as="as"
                @click="handlePageClick($event)"
                :href="`${url}${separator}${RequestQueryKeyEnum.PaginationPage}=${page}`"
                color="light"
                :data-page="page"
            >
                {{ page }}
            </Button>
        </template>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import { type PaginatedResultsType } from '@/Shared/AutoGenerated/Main'
    import { RequestQueryKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const emits = defineEmits<{
        onClick: [{ event: Event; page: number }]
    }>()

    const props = defineProps({
        searchResults: {
            type: Object as PropType<PaginatedResultsType>,
            required: true,
        },
        as: {
            type: String as PropType<'a' | 'button'>,
            default: 'a',
        },
        url: {
            type: String,
            default: '',
        },
    })

    const separator = props.url.includes('?') ? '&' : '?'

    const handlePageClick = (event: Event) => {
        if (props.as === 'a') {
            return
        }

        const target = event.target as HTMLElement | null

        if (target === null) {
            throw new Error('Event.target should not be null')
        }

        const page = target.dataset.page

        if (page === undefined) {
            throw new Error('page should not be undefined')
        }

        emits('onClick', {
            event: event,
            page: parseInt(page),
        })
    }
</script>
